import { Flex, Form } from "antd"

import ButtonComponent from "../../../../../Components/Button"
import InputComponent from "../../../../../Components/Input"
import InputNumberComponent from "../../../../../Components/Input/InputNumber"
import Icon from "../../../../../Icon"

// Up to 8 digits before the decimal point, two after (CHA1-3031 validation).
const MAX_PRICE = 99999999.99

const defaultValues = { free_count: 0 }

const PRICE_FIELDS = [
  { name: "banking_app_price", label: "Banking app price ($)" },
  { name: "call_center_price", label: "Call Center price ($)" },
  { name: "mastercom_price", label: "Mastercom price ($)" }
]

const addErrorIcon = (error) => (
  <span>
    <Icon type={"alert_triangle_error"} /> {error}
  </span>
)

// The lookup counterpart of PricingForm: always fixed-price, three channel prices and one shared
// free-lookup allowance.
function LookupPricingForm({ onClose, onSubmit, initialValues, pricingNames, isDefault }) {
  const [form] = Form.useForm()

  const validateUnique = (_, value) => {
    // Case-sensitive, like the backend: "enterprise" and "Enterprise" are different schemes.
    const name = value?.trim()
    const isOwnName = initialValues?.name === name

    if (name && !isOwnName && pricingNames?.includes(name)) {
      return Promise.reject(new Error(`Pricing with the name '${value.trim()}' already exists.`))
    }

    return Promise.resolve()
  }

  const onFocusHandler = (e) => {
    const field = e.target.name || e.target.id

    if (field) form.setFields([{ name: field, errors: [] }])
  }

  const onFinish = ({ name, ...values }) => onSubmit({ ...values, name: name.trim() })

  return (
    <Form
      className={"with-default-error"}
      onFinish={onFinish}
      validateTrigger="onSubmit"
      validateMessages={{ required: addErrorIcon("Required fields were not filled.") }}
      layout="vertical"
      form={form}
      initialValues={initialValues || defaultValues}
    >
      <Form.Item
        name="name"
        label="Name"
        rules={[
          { required: true, whitespace: true },
          { max: 255, message: addErrorIcon("Name can not be longer than 255 characters.") },
          { validator: validateUnique }
        ]}
      >
        <InputComponent
          placeholder="Enter a new pricing scheme name"
          name="name"
          disabled={isDefault}
          onFocus={onFocusHandler}
        />
      </Form.Item>

      <Form.Item
        label="Number of the first lookups to skip"
        name="free_count"
        rules={[{ required: true }]}
      >
        <InputNumberComponent
          id="free_count"
          placeholder="Enter the number of lookups"
          onFocus={onFocusHandler}
          min={0}
          step={1}
          precision={0}
          style={{ width: "100%" }}
        />
      </Form.Item>

      {PRICE_FIELDS.map(({ name, label }) => (
        <Form.Item key={name} label={label} name={name} rules={[{ required: true }]}>
          <InputNumberComponent
            id={name}
            placeholder="Price e.g $1.00"
            onFocus={onFocusHandler}
            min={0.01}
            max={MAX_PRICE}
            step={0.5}
            precision={2}
            style={{ width: "100%" }}
          />
        </Form.Item>
      ))}

      <Flex gap={16} justify="end" style={{ padding: "0 3px 3px 3px" }}>
        <ButtonComponent size="large" htmlType="button" onClick={onClose}>
          Cancel
        </ButtonComponent>

        <ButtonComponent size="large" type="primary" htmlType="submit">
          {initialValues ? "Save changes" : "Create pricing scheme"}
        </ButtonComponent>
      </Flex>
    </Form>
  )
}

export default LookupPricingForm
